import { ReactPlugin } from '@microsoft/applicationinsights-react-js'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { Router, State } from 'router5'

const createRouterHistory = (router: Router, state?: State) => {
  return {
    location: { pathname: state ? state.path : '/' },
    listen: (listener: (location: Location) => void) => {
      router.subscribe(({ route }) => {
        listener({ pathname: route.path } as any)
      })
    },
  }
}

export function loadAppInsights(router: Router, state?: State) {
  if (!process.env.REACT_APP_INSTRUMENTATION_KEY) {
    return
  }
  const routerHistory = createRouterHistory(router, state)
  const reactPlugin = new ReactPlugin()
  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY,
      extensions: [reactPlugin],
      extensionConfig: {
        [reactPlugin.identifier]: { history: routerHistory },
      },
    },
  })
  appInsights.loadAppInsights()
}
